import React from 'react'
import PropTypes from 'prop-types'
import { YesNoDialog } from '~/views'
import ProjectSelector from './ProjectSelector'

const NAMES = {
  system : 'System',
  blueprint : 'Blueprint',
  scenario : 'Scenario',
  network : 'Network'
}

export default class TransferToProjectDialog extends React.Component {

  static propTypes = {
    projects : PropTypes.object.isRequired,
    objType : PropTypes.string.isRequired,
    object : PropTypes.object,
    onTransfer : PropTypes.func.isRequired,
    onCancel : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.state = { current : null }
  }
  
  getTypeName() {
    return NAMES[this.props.objType] || 'Unknown'
  }

  onTransfer = ( ) => {
    if ( this.state.current ) {
      this.props.onTransfer( this.props.object, this.state.current )
    }
  }

  onProjectSelected = ( current ) => {
    console.log( 'selected', current )
    this.setState( { current } )
  }

  render() {
    
    const { current } = this.state
    const { projects, objType, object, show } = this.props
    
    if ( !show || object == null ) {
      return null
    }

    const name = this.getTypeName( objType )

    return (

      <YesNoDialog show
        bsSize="small"
        title={`Transfer ${object.name}`}
        yes="Transfer"
        no="Cancel"
        message={(
          <div style={{ textAlign : 'center' }}>
            <div style={{ fontSize : '16px', margin : '10px' }}>
              Which project do you wish to transfer the
              {' '}
              {objType}
              {' '}
              to?
            </div>
            <ProjectSelector projects={projects} current={current && current.id} filter={[ object.projectId ]} onSelect={this.onProjectSelected} />
          </div>
        )}
        onYes={this.onTransfer}
        onNo={this.props.onCancel} />
    );
  }
}
